import React, { useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import PropTypes from 'prop-types';
import {
  optionsSpecialty,
  optionsSkill,
  optionsEMR
} from 'nursd-dashboard/data/defaultData';
import makeAnimated from 'react-select/animated';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';

const ProfileSettings = ({
  formData,
  setFormData,
  valueSpecialty,
  setValueSpecialty,
  valueSkill,
  setValueSkill,
  valueEMR,
  setValueEMR
}) => {
  const animatedComponents = makeAnimated();

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
  };
  const [optionsLicense] = useState(['LPN', 'CNA', 'HHA', 'RN']);

  return (
    <Card>
      <FalconCardHeader title="Profile Settings" />
      <Card.Body className="bg-body-tertiary">
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3 g-3">
            <Form.Group as={Col} lg={6} controlId="firstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="First Name"
                value={formData.firstName}
                name="firstName"
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group as={Col} lg={6} controlId="lastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Last Name"
                value={formData.lastName}
                name="lastName"
                onChange={handleChange}
              />
            </Form.Group>
          </Row>
          <Row className="mb-3 g-3">
            <Form.Group as={Col} lg={6} controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                disabled
                type="email"
                placeholder="Email"
                value={formData.email}
                name="email"
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group as={Col} lg={6} controlId="phone">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="text"
                placeholder="Phone"
                value={formData.phone}
                name="phone"
                onChange={handleChange}
              />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="PrimaryLicenseType">
              <Form.Label>Primary LicenseType</Form.Label>
              <Form.Select
                onChange={e =>
                  setFormData(prevState => {
                    return { ...prevState, primaryLicenseType: e.target.value };
                  })
                }
                size="sm"
                required
                value={formData?.primaryLicenseType}
              >
                <option value="">Select LicenseType</option>
                {optionsLicense.map(option => (
                  <option key={option}>{option}</option>
                ))}
              </Form.Select>
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please choose a license type.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="2" controlId="Internal">
              <Form.Check
                type="checkbox"
                id="Internal"
                label="Internal Pool"
                className="mt-2"
                checked={formData.poolType === 'Internal Pool'}
                onChange={() =>
                  handleChange({
                    target: {
                      name: 'poolType',
                      value: 'Internal Pool'
                    }
                  })
                }
              />
            </Form.Group>
            <Form.Group as={Col} md="2" controlId="Float">
              <Form.Check
                type="checkbox"
                id="Float"
                label="Float Pool"
                className="mt-2"
                checked={formData?.poolType === 'Float Pool'}
                onChange={() =>
                  handleChange({
                    target: {
                      name: 'poolType',
                      value: 'Float Pool'
                    }
                  })
                }
              />
            </Form.Group>
          </Row>
          <Row className="mb-3 g-3">
            <Form.Group as={Col} md="6" controlId="ClinicalLicenseNumber">
              <Form.Label>Clinical License Number</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Clinical License Number"
                name="clinicalLicenseNumber"
                value={formData.clinicalLicenseNumber}
                onChange={handleChange}
                // pattern="[0-9]*"
              />
            </Form.Group>
            <Form.Group
              as={Col}
              md="6"
              controlId="clinicalLicenseExpirationDate"
            >
              <Form.Label>Clinical License Expiration Date</Form.Label>
              <DatePicker
                popperPlacement="bottom-start"
                selected={formData.clinicalLicenseExpirationDate}
                onChange={date =>
                  setFormData(prevState => {
                    return {
                      ...prevState,
                      clinicalLicenseExpirationDate: date
                    };
                  })
                }
                formatWeekDay={day => day.slice(0, 3)}
                className="form-control"
                placeholderText="Select Date"
              />
            </Form.Group>
          </Row>

          {/* <Form.Group className="mb-3" controlId="heading">
            <Form.Label>Heading</Form.Label>
            <Form.Control
              type="text"
              placeholder="Heading"
              value={formData.heading}
              name="heading"
              onChange={handleChange}
            />
          </Form.Group> */}

          {/* <Form.Group className="mb-3" controlId="intro">
            <Form.Label>Intro</Form.Label>
            <Form.Control
              as="textarea"
              rows={13}
              placeholder="Intro"
              value={formData.intro}
              name="intro"
              onChange={handleChange}
            />
          </Form.Group> */}
          <Row className="mb-3">
            <Form.Group as={Col} md="4" className="mb-2" controlId="License">
              <Form.Label className="fs-9">Select Specialty</Form.Label>
              <Select
                closeMenuOnSelect={false}
                options={optionsSpecialty}
                placeholder="Select..."
                isMulti
                classNamePrefix="react-select"
                value={valueSpecialty}
                onChange={value => {
                  setValueSpecialty(value);
                }}
                components={animatedComponents}
                required
              />
            </Form.Group>
            <Form.Group as={Col} md="4" className="mb-2" controlId="License">
              <Form.Label className="fs-9">Select Skills</Form.Label>
              <Select
                closeMenuOnSelect={false}
                options={optionsSkill}
                placeholder="Select..."
                isMulti
                classNamePrefix="react-select"
                value={valueSkill}
                onChange={value => {
                  setValueSkill(value);
                }}
                components={animatedComponents}
                required
              />
            </Form.Group>
            <Form.Group as={Col} md="4" className="mb-2" controlId="License">
              <Form.Label className="fs-9">
                Select EMR/EHR Experience
              </Form.Label>
              <Select
                closeMenuOnSelect={false}
                options={optionsEMR}
                placeholder="Select..."
                isMulti
                classNamePrefix="react-select"
                value={valueEMR}
                onChange={value => {
                  setValueEMR(value);
                }}
                components={animatedComponents}
                required
              />
            </Form.Group>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

ProfileSettings.propTypes = {
  formData: PropTypes.any,
  setFormData: PropTypes.any,
  valueSpecialty: PropTypes.any,
  setValueSpecialty: PropTypes.any,
  valueSkill: PropTypes.any,
  setValueSkill: PropTypes.any,
  valueEMR: PropTypes.any,
  setValueEMR: PropTypes.any
};

export default ProfileSettings;
